import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { EntitySelector } from "./entitySelector";
/**
 * A primitive component with a ComboBox for selecting from existing scene nodes.
 * @param props NodeSelectorProps
 * @returns NodeSelector component
 */
export const NodeSelector = (props) => {
    NodeSelector.displayName = "NodeSelector";
    const { scene, ...rest } = props;
    const getNodes = useCallback(() => scene.getNodes(), [scene]);
    const getName = useCallback((node) => node.name, []);
    return _jsx(EntitySelector, { ...rest, getEntities: getNodes, getName: getName });
};
//# sourceMappingURL=nodeSelector.js.map